import { createAction, props } from '@ngrx/store';
import { ConsumerPortalConfig } from '../../../models';

export enum ConfigActionTypes {
    SetConfig = '[Config] Set Config'
}

export const setConfig = createAction(ConfigActionTypes.SetConfig, props<{ config: ConsumerPortalConfig }>());
